import { render } from "./fb3.vue?vue&type=template&id=1b152473&scoped=true"
import script from "./fb3.vue?vue&type=script&lang=js"
export * from "./fb3.vue?vue&type=script&lang=js"

import "./fb3.vue?vue&type=style&index=0&id=1b152473&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b152473"]])

export default __exports__